'use client';

import { processCommonProps } from "./processCommonProps.js";
import { hasDarkBackground } from "./hasDarkBackground.js";
import { getLoadingSize } from "./getLoadingSize.js";
function processButtonProps(props) {
  const {
    propsToSpread: {
      a11yLoadingLabel,
      a11ySuccessLabel,
      className,
      isSuccess,
      isLoading,
      onClick,
      ref,
      ...propsToSpread
    },
    ...p
  } = processCommonProps(props);
  const horizontalCompactSpaceType = p.disabled ? "compactDisabled" : "compact";
  return {
    ...p,
    a11yLoadingLabel,
    a11ySuccessLabel,
    className,
    horizontalCompactSpaceType,
    horizontalSpaceType: p.emphasis === "lowCompact" ? horizontalCompactSpaceType : "default",
    isLoading,
    isLoadingSpinnerOnDark: hasDarkBackground(p),
    isSuccess,
    loadingSize: getLoadingSize(p),
    onClick,
    propsToSpread,
    ref
  };
}
export {
  processButtonProps
};
